<template>
  <div class="mb-12" :class="$vuetify.breakpoint.name === 'lg' ? 'pr-12 pl-8' : 'px-3'">
    <v-dialog v-model="dialog.form" persistent max-width="400">
      <v-card class="pa-3">
        <div class="text-center">
          <v-avatar>
            <v-icon x-large>mdi-comment-account</v-icon>
          </v-avatar>
        </div>
        <div class=" mt-10">
          <v-list-item-title
            class="body-2 grey--text text--darken-2">
            <p class="caption grey--text text-lighten-4 mb-1">
              Nama
            </p>
            {{ detail.questionName }}
          </v-list-item-title>
          <v-list-item-title
            class="body-2 grey--text text--darken-2 mt-2">
            <p class="caption grey--text text-lighten-4 mb-1">
              Email
            </p>
            {{ detail.questionEmail }}
          </v-list-item-title>
          <v-list-item-title
            class="body-2 grey--text text--darken-2 mt-2">
            <p class="caption grey--text text-lighten-4 mb-1">
              Tanggal
            </p>
            {{ detail.questionDateCreated | date }}
          </v-list-item-title>
          <p class="caption grey--text text-lighten-4 mt-2 mb-1">
            Pertanyaan
          </p>
          <p class="body-2 grey--text text--darken-2"
            v-html="detail.questionText">
          </p>
        </div>
        <v-card-actions class="pb-5">
          <v-spacer></v-spacer>
          <v-btn
            rounded
            small
            width="100"
            elevation="0"
            class="text-capitalize"
            @click="showPage = false; dialog.form = false">
            Tutup
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row>
      <v-col cols="12" :sm="showPage === false ? '12' : '8'">
        <div :class="$vuetify.breakpoint.name !== 'xs' ? 'd-flex' : ''">
          <v-text-field
            filled
            rounded
            dense
            :hide-details="true"
            placeholder="Cari pertanyaan . . ."
            v-model="filter.username"
            clearable
            color=" #fc2d63"
            @click:clear="filter.username = ''; fetch()"
            v-on:keyup.enter="fetch()"
            prepend-inner-icon="mdi-magnify">
          </v-text-field>
          <v-btn
            color="#F5F5F5"
            :width="$vuetify.breakpoint.name === 'xs' ? '100%' : '200'"
            class="text-capitalize"
            :class="$vuetify.breakpoint.name === 'xs' ? 'mt-3' : 'mx-3'"
            elevation="0"
            rounded
            light
            v-if="showPage"
            @click="showPage = false">
            <span v-if="showPage">Kembali</span>
          </v-btn>
        </div>
        <div class="my-5">
          <div class="title text--secondary">Data Pertanyaan</div>
          <div class="caption text--secondary">{{pagination.totalData}} Pertanyaan Ditemukan</div>
          <v-skeleton-loader
            class="ma-auto"
            :loading="process.run"
            transition="scale-transition"
            :tile="false"
            type="list-item-avatar-two-line"
            v-for="(l, index) in process.run ? 10:list"
            :key="index">
            <v-list dense class="line my-3 mr-5">
              <v-list-item>
                <v-list-item-avatar @click="$vuetify.breakpoint.name === 'xs' ? toDetail(l, 'mobile') : $vuetify.breakpoint.name === 'sm' ? toDetail(l, 'mobile') : toDetail(l)" class="cursor-pointer mr-3">
                  <v-icon>mdi-comment-account</v-icon>
                </v-list-item-avatar>
                <v-list-item-content @click="$vuetify.breakpoint.name === 'xs' ? toDetail(l, 'mobile') : $vuetify.breakpoint.name === 'sm' ? toDetail(l, 'mobile') : toDetail(l)" class="cursor-pointer">
                  <v-list-item-title
                    class="body-2 font-weight-bold grey--text text--darken-2">
                  {{l.questionName}}
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-content @click="$vuetify.breakpoint.name === 'xs' ? toDetail(l, 'mobile') : $vuetify.breakpoint.name === 'sm' ? toDetail(l, 'mobile') : toDetail(l)" class="cursor-pointer">
                  <v-list-item-title class="body-2 grey--text text--darken-2 d-flex">
                    <div>
                      <v-icon class="mr-2">mdi-email</v-icon>
                      {{l.questionEmail}}
                    </div>
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-content class="ml-3 text-right">
                  <div>
                    <v-btn
                      fab
                      x-small
                      color="#F0932B"
                      elevation="0"
                      class="text-capitalize white--text ma-1"
                      to="/config/help">
                      <v-icon small>mdi-check-bold</v-icon>
                    </v-btn>
                  </div>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-skeleton-loader>
          <Empty v-show="!process.run && list.length < 1" content="Data Pertanyaan"/>
        </div>
        <div v-if="pagination.totalPage > 1">
          <v-row>
            <v-col cols="5">
              <div class="body-2	font-weight-bold mt-4">
                Total {{ pagination.totalData }} data
              </div>
            </v-col>
            <v-col cols="7">
              <div class="float-right">
                <v-pagination
                  v-model="page"
                  :length="pagination.totalPage"
                  :total-visible="5"
                  color=" #fc2d63"
                  @input="fetch(page)"
                  circle>
                </v-pagination>
              </div>
            </v-col>
          </v-row>
        </div>
      </v-col>

      <v-col cols="12" sm="4" class="background-bank-cols" v-if="showPage && $vuetify.breakpoint.name !== 'xs'">
        <div class="background-default pa-5">
          <div class="text-center">
            <v-avatar>
              <v-icon x-large>mdi-comment-account</v-icon>
            </v-avatar>
          </div>
          <div class=" mt-10">
            <v-list-item-title
              class="body-2 grey--text text--darken-2">
              <p class="caption grey--text text-lighten-4 mb-1">
                Nama
              </p>
              {{ detail.questionName }}
            </v-list-item-title>
            <v-list-item-title
              class="body-2 grey--text text--darken-2 mt-2">
              <p class="caption grey--text text-lighten-4 mb-1">
                Email
              </p>
              {{ detail.questionEmail }}
            </v-list-item-title>
            <v-list-item-title
              class="body-2 grey--text text--darken-2 mt-2">
              <p class="caption grey--text text-lighten-4 mb-1">
                Tanggal
              </p>
              {{ detail.questionDateCreated | date }}
            </v-list-item-title>
            <p class="caption grey--text text-lighten-4 mt-2 mb-1">
              Pertanyaan
            </p>
            <p class="body-2 grey--text text--darken-2"
              v-html="detail.questionText">
            </p>
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "../../../../service/Axios";
  import Empty from "../../../../components/DataEmpty"; 
  export default {
    data() {
      return {
        dialog: {
          form: false
        },
        showPage: false,
        filter: {
          username: ""
        },
        detail: {},
        list: [],
        pagination: {},
        page: 1,
        process: {
          run: false
        },
        response: ""
      }
    },
    components: {
      Empty 
    },
    mounted() {
      window.scrollTo(0, 0)
      this.fetch()
    },
    methods: {
      async fetch(p) {
        this.process.run = true;
        await get(`api/internal/question`, {
          params: {
            pagenum: p,
            limit: 10,
            search: this.filter.username ? 'question_name:'+this.filter.username : ''
          }
        }).then(response => {
          let res = response.data
          if (res.code === 200) {
            this.process.run = false
            this.list = res.data
            this.pagination = res.pagination
          }
        })
      },
      toDetail(item, status) {
        this.detail = item
        this.detail.questionText = this.detail.questionText.replace(/&lt;/g, "<");
        this.showPage = status !== undefined ? false : true
        this.dialog.form = status !== undefined ? true : false
      }
    }
  }
</script>